import { ModalClosed } from "~misc/icons";

const ModalImage = ({ isOpen, closeModal, children, childrenClass }) => {
  const modalClasses = isOpen ? 'fixed inset-0 bg-black bg-opacity-0 z-[99999]' : 'hidden';
  const overlayClasses = isOpen ? 'fixed inset-0 bg-black opacity-50 z-40' : 'hidden';

  return (
    <div className={modalClasses}>
      <div className="fixed inset-0 flex items-center justify-center z-50">
        <div className="bg-white px-14 py-14 rounded-[20px] shadow-lg z-50 text-center relative">
          <div className="flex justify-end">
            <button
              type="button"
              onClick={closeModal}
              className="text-gray-500 p-4 rounded-tr-[20px] hover:text-gray-700 bg-quinaria absolute top-0 right-0"
            >
               <ModalClosed />
            </button>
          </div>

          <div className={`max-w-[430px] ${childrenClass} `}>
            {children}
          </div>


        </div>
        <div className={overlayClasses} onClick={closeModal}></div>
      </div>
    </div>
  );
};

export default ModalImage;